import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo_icon from '../assets/logo_icon.png';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, setCookie } from "../Helpers";
import { MdArrowCircleRight } from "react-icons/md";
import {
  STR_CHANGE_LANGUAGE,
  STR_CONTINUE,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PHONE,
  STR_PLEASE_WAIT,
  STR_RESEND_OTP,
  STR_WELCOME,
  STR_YOUR_PHONE,
  STR_PHONE_NUMBER,
  STR_YOUR_OTP_VERIFICATION,
  STR_CHANGE_PHONE,
  STR_INTRO_2
} from "../Strings";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loginStep, setLoginStep] = useState("identity");

  async function init() {
    const storedPhone = getCookie("phone");
    const storedLoginStep = getCookie("loginStep");

    if (storedPhone) {
      setPhone(storedPhone);
    }

    if (storedLoginStep) {
      setLoginStep(storedLoginStep);
    }
  }

  async function resendOtp() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {

        setLoading(true);
        await callApi(
          "resend-otp",
          {
            phone: `255${parseInt(phone, 10)}`,
            identity: 'phone',
            email: ''
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function phoneLogin() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {

        setLoading(true);
        await callApi(
          "phone-login",
          {
            phone: `255${parseInt(phone, 10)}`,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function forgotPassword() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {

        setLoading(true);
        await callApi(
          "forgot-password",
          {
            phone: `255${parseInt(phone, 10)}`,
            email: '',
            identity: 'phone',
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function otpLogin() {
    if (!loading) {
      if (otp.trim().length === 6) {

        setLoading(true);
        await callApi(
          "otp-login",
          {
            phone: `255${parseInt(phone, 10)}`,
            otp,
            identity: 'phone',
            email: '',
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', '');
            setCookie('loginStep', '');

            setCookie("userId", response.user.id);
            setCookie("userToken", response.user.token);

            appContext.navTo({
              item: 'home',
            })

            //refresh app
            appContext.refresh(); //delay hack

            appContext.tellMessage(STR_WELCOME[appContext.language]);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_OTP[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  function renderTopBrand() {
    return (
      <div
        style={{
          paddingTop: "24px",
          paddingBottom: "18px",
          textAlign: "center",
        }}
      >
        <div
          className="mShadow2"
          style={{
            width: "78px",
            height: "78px",
            borderRadius: "26px",
            background: "rgba(255,255,255,0.65)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(0,0,0,0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            overflow: "hidden",
          }}
        >
          <img
            src={logo_icon}
            style={{
              width: "44px",
              height: "44px",
              objectFit: "contain",
            }}
          />
        </div>

        <div style={{ marginTop: "14px" }}>
          <img
            src={logo_worded_only}
            style={{
              width: "190px",
              height: "auto",
            }}
          />
        </div>

        <p
          className="mNoMargin font-regular"
          style={{
            marginTop: "10px",
            fontSize: "13px",
            opacity: 0.75,
            lineHeight: "18px",
            paddingLeft: "12px",
            paddingRight: "12px",
          }}
        >
          {STR_INTRO_2[appContext.language]}
        </p>
      </div>
    )
  }

  function renderShell(children) {
    return (
      <div
        className="bg-sub-gradient"
        style={{
          width: "100%",
          height: "100%",
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* soft blobs */}
        <div
          style={{
            position: "absolute",
            width: "360px",
            height: "360px",
            borderRadius: "360px",
            top: "-140px",
            left: "-140px",
            background: "radial-gradient(circle at 30% 30%, rgba(11,111,182,0.25), rgba(11,111,182,0) 60%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "420px",
            height: "420px",
            borderRadius: "420px",
            bottom: "-180px",
            right: "-180px",
            background: "radial-gradient(circle at 60% 40%, rgba(123,192,67,0.25), rgba(123,192,67,0) 60%)",
            pointerEvents: "none",
          }}
        />

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          {children}
        </div>
      </div>
    )
  }

  function renderCard(title, subtitle, body, footer) {
    return (
      <div
        style={{
          maxWidth: "420px",
          margin: "0 auto",
          paddingBottom: "26px",
        }}
      >
        <div
          className="mShadow3"
          style={{
            borderRadius: "26px",
            background: "rgba(244,244,244,0.80)",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            border: "1px solid rgba(0,0,0,0.06)",
            overflow: "hidden",
          }}
        >
          {/* header */}
          <div
            style={{
              padding: "18px",
              paddingBottom: "14px",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "4px",
                borderRadius: "10px",
                background: "linear-gradient(90deg, var(--primaryColor), var(--secondaryColor))",
                marginBottom: "14px",
              }}
            />

            <h6 className="mNoMargin font-semi-bold" style={{ fontSize: "18px" }}>
              {title}
            </h6>

            <p
              className="mNoMargin font-regular"
              style={{
                marginTop: "6px",
                fontSize: "13px",
                opacity: 0.75,
                lineHeight: "18px",
              }}
            >
              {subtitle}
            </p>
          </div>

          {/* body */}
          <div style={{ padding: "18px", paddingTop: "0px" }}>
            {body}
          </div>

          {/* footer */}
          {
            footer ?
              <div
                style={{
                  padding: "16px 18px",
                  borderTop: "1px solid rgba(0,0,0,0.06)",
                  background: "rgba(255,255,255,0.35)",
                }}
              >
                {footer}
              </div>
              : ""
          }
        </div>
      </div>
    )
  }

  function renderPrimaryButton(label, onClick) {
    return (
      <button
        className="btn btn-rounded btn-padded btn-primary btn-block"
        style={{
          fontSize: "15px",
          textTransform: "uppercase",
        }}
        onClick={onClick}
      >
        {label}
      </button>
    )
  }

  function renderLinkRow(items) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {
          items.map((x, i) => (
            <h6
              key={i}
              style={{
                cursor: "pointer",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
              className="text-primary font-bold mNoMargin"
              onClick={x.onClick}
            >
              <MdArrowCircleRight size={16} />
              {x.label}
            </h6>
          ))
        }
      </div>
    )
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <>
      {renderShell(
        <div style={{ paddingBottom: "34px" }}>

          {renderTopBrand()}

          {/* PHONE STEP */}
          {
            (loginStep === 'identity') ?
              <>
                {renderCard(
                  `${STR_YOUR_PHONE[appContext.language]}!`,
                  STR_ENTER_YOUR_PHONE_NUMBER[appContext.language],
                  <>

                    <div className="input-group" style={{ marginTop: "8px" }}>
                      <span
                        className="input-group-text font-semi-bold text-secondary"
                        style={{ fontSize: "16px" }}
                      >
                        +255
                      </span>
                      <input
                        className="form-control"
                        onChange={(e) => setPhone(_prev => {
                          if (Number(e.target.value)) {
                            return Number(e.target.value);
                          } else if (String(e.target.value).trim().length === 0) {
                            return "";
                          } else {
                            return _prev;
                          }
                        })}
                        value={phone}
                        maxLength={10}
                        placeholder="XXX XXX XXX"
                        type="text"
                        style={{ fontSize: "16px" }}
                      />
                    </div>

                    

                    <div style={{ marginTop: "48px" }}>
                      {renderLinkRow([
                        {
                          label: STR_FORGOT_PASSWORD[appContext.language],
                          onClick: () => forgotPassword(),
                        },
                        {
                          label: STR_CHANGE_LANGUAGE[appContext.language],
                          onClick: () => appContext.changeLanguage(),
                        },
                      ])}
                    </div>

                    <div style={{ marginTop: "18px" }}>
                      {renderPrimaryButton(
                        STR_CONTINUE[appContext.language],
                        () => phoneLogin()
                      )}
                    </div>
                  </>,
                  ""
                )}
              </>
              : ""
          }

          {/* OTP STEP */}
          {
            (loginStep === 'otp') ?
              <>
                {renderCard(
                  `${STR_YOUR_OTP_VERIFICATION[appContext.language]}!`,
                  STR_ENTER_OTP[appContext.language],
                  <>
                    <input
                      className="form-control"
                      onChange={e => setOtp(e.target.value)}
                      value={otp}
                      maxLength={6}
                      placeholder="------"
                      style={{
                        fontSize: "18px",
                        letterSpacing: "6px",
                        textAlign: "center",
                        marginTop: "8px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                      }}
                    />
                    

                    <div style={{ marginTop: "48px" }}>
                      {renderLinkRow([
                        {
                          label: STR_CHANGE_PHONE[appContext.language],
                          onClick: () => setLoginStep('identity'),
                        },
                        {
                          label: STR_RESEND_OTP[appContext.language],
                          onClick: () => resendOtp(),
                        },
                        {
                          label: STR_CHANGE_LANGUAGE[appContext.language],
                          onClick: () => appContext.changeLanguage(),
                        },
                      ])}
                    </div>

                    <div style={{ marginTop: "18px" }}>
                      {renderPrimaryButton(
                        STR_CONTINUE[appContext.language],
                        () => otpLogin()
                      )}
                    </div>
                  </>,
                  ""
                )}
              </>
              : ""
          }

        </div>
      )}
    </>
  )
}
